<script>
    import { wishlist } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/wishlist.js?1733898724894';
    import Badge from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Badge.svelte?1733898724894';
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    export let store;

    $: count = get_count($wishlist);
    $: url = `/${[store, 'wunschliste'].filter(Boolean).join('/')}/`;

    ;

    onMount(() => {
        // KW-1311 - Toggle wishlist event can be used like this: trigger("toggleWishlist:ab", {"sku": "<sku>"})
        const toggle_event = 'toggleWishlist:ab';
        on(toggle_event, (data) => {
            if (!data) {
                console.error(toggle_event, 'missing data');
                return;
            }
            const { sku } = data;
            if (!sku) {
                console.error(toggle_event, 'missing sku');
                return;
            }
            wishlist.toggle(sku);
        });

        // KW-1311 - Add to wishlist event can be used like this: trigger("addToWishlist:ab", {"sku": "<sku>"})
        const add_event = 'addToWishlist:ab';
        on(add_event, (data) => {
            if (!data) {
                console.error(add_event, 'missing data');
                return;
            }
            const { sku } = data;
            if (!sku) {
                console.error(add_event, 'missing sku');
                return;
            }
            if (wishlist.get()?.items.indexOf(sku) === -1) {
                wishlist.toggle(sku);
            }
        });
    });

    function get_count(wishlist) {
        if (!wishlist || !wishlist.items) {
            return 0;
        }
        return Object.keys(wishlist.items).length;
    }
</script>

<section>
    <form method="POST" action="/redir/" class="m-navigation__link">
        <input type="hidden" name="url" value={url} />
        <input type="hidden" name="requestdata" value="/de/wunschliste/" />
        <button class="m-navigation__menu-text">
            <i class="icon-add-to-wishlist" />
            <span>Wunschliste</span>
            {#if count > 0}
                <Badge>{count}</Badge>
            {/if}
        </button>
    </form>
</section>


<style>
    section {
        position: relative;
        white-space: nowrap;
        hyphens: auto;
        word-wrap: break-word;
        word-break: break-word;
    }

    .icon-add-to-wishlist:before {
        color: #040b1c;
    }

    section form button span {
        font-size: var(--h6__font-size-desktop);
        font-weight: var(--h6__font-weight);
        line-height: var(--h6__line-height);
        color: var(--h6__color);
        margin: var(--h6__margin);
        text-transform: none;
    }

    @media (max-width: 992px) {
        section form button span {
            font-size: 0.65rem !important;
        }
        section > form {
            padding: 5px !important;
        }
    }

    section > form {
        -webkit-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;

        padding: 8px 16px;
        cursor: pointer;
        color: var(--color-text);
        text-decoration: none;
        -webkit-transition: color 0.5s linear;
        transition: color 0.5s linear;
        display: inline-block;
    }
    section > form:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: var(--color-text);
        opacity: 0;
        pointer-events: none;
        z-index: 0;
        font-size: 20px !important;
        -webkit-transition: opacity 0.5s linear;
        transition: opacity 0.5s linear;
    }
    @media (min-width: 992px) {
        section > form:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: var(--color-text);
            opacity: 0;
            z-index: 0;
        }
    }

    section > form {
        color: var(--color-primary);
        padding: 8px 16px;
        cursor: pointer;
        color: var(--darkgray);
        text-decoration: none;
        webkit-transition: 0.5s ease-in-out !important;
        transition: 0.5s ease-in-out !important;
        display: inline-block;
    }

    section > form:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: var(--color-text);
        opacity: 0;
        pointer-events: none;
        z-index: 0;
        transition: opacity var(--module-navigation-speed) linear;
    }

    section > form:hover {
        background-color: #eeeeee;
    }

    .m-navigation__menu-text {
        padding-left: 0;
        padding-right: 0;
    }

    section form button i {
        font-family: 'kofferworld';
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-bottom: 10px;
        display: block;
        font-size: 20px;
    }

    section form button {
        border: none;
        outline: none;
        background-color: transparent;
    }

    @media (max-width: 992px) {
        button {
            padding: 0px !important;
        }
    }
</style>